import { EventStatus } from "@ticketingplatform/api/dist/__generated__/globalTypes";
import { Button, Divider, Form, Space } from "antd";
import MainCreationForm from "components/forms/MainCreationForm";
import Tabs from "components/layout/Tabs";
import { FC } from "react";
import { FormattedMessage } from "react-intl";

import { useEventFormSubmitButtons, useEventFormTabs } from "./hooks";
import { EventFormProps } from "./types";
import PreviewBox from "./PreviewBox";

const EventForm: FC<EventFormProps> = ({
  eventType,
  disabled,
  form,
  loading,
  eventUrlIds,
  eventStatus = EventStatus.DRAFT,
  ...props
}) => {
  const { onDraft, onPublish } = useEventFormSubmitButtons(form);
  const items = useEventFormTabs(eventType);

  return (
    <MainCreationForm
      layout="vertical"
      disabled={disabled || loading}
      {...{ form, ...props }}
    >
      {(_, __, { isSubmitting }) => (
        <>
          <Tabs {...{ items }} />
          <Divider />
          <PreviewBox eventUrlIds={eventUrlIds} />
          <Space>
            {eventStatus === EventStatus.DRAFT ? (
              <>
                <Form.Item name={["input", "status"]}>
                  <Button
                    type="default"
                    htmlType="submit"
                    onClick={onDraft}
                    size="large"
                    loading={isSubmitting}
                    {...{ disabled }}
                  >
                    <FormattedMessage defaultMessage="Save as a draft" />
                  </Button>
                </Form.Item>
                <Form.Item name={["input", "status"]}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={onPublish}
                    size="large"
                    loading={isSubmitting}
                    {...{ disabled }}
                  >
                    <FormattedMessage defaultMessage="Publish event" />
                  </Button>
                </Form.Item>
              </>
            ) : (
              <Form.Item name={["input", "status"]}>
                <Button
                  type="default"
                  htmlType="submit"
                  onClick={onPublish}
                  size="large"
                  disabled={disabled || false}
                  loading={isSubmitting}
                >
                  <FormattedMessage defaultMessage="Save" />
                </Button>
              </Form.Item>
            )}
          </Space>
        </>
      )}
    </MainCreationForm>
  );
};

export default EventForm;
